import React, { useContext, useEffect, useState } from 'react';
import AdminButton from '../commonComponents/AdminButton';
import TableMaker from '../commonComponents/TableMaker';
import '../../styles/components/admin/styles.scss';
import { Context } from '../../index';
import { useNavigate } from 'react-router-dom';
import { deleteDoctor, fetchDoctor, fetchDoctors } from '../../http/doctorAPI';
import { deleteBooking, fetchBooking, fetchBookings } from '../../http/bookingAPI';

import DoctorModal from '../modals/DoctorModal';
import UpdateBookingModal from '../modals/UpdateBookingModal';
import AddVacancyModal from '../modals/AddVacancyModal';
import { deleteVacancy, fetchVacancies, fetchVacancy } from '../../http/vacancyAPI';
import UpdateVacancyModal from '../modals/UpdateVacancyModal';
import { deleteSpecialOffer, fetchSpecialOffer, fetchSpecialOffers } from '../../http/specialOfferAPI';
import UpdateSpecialOfferModal from '../modals/UpdateSpecialOfferModal';
import { fetchFeedback, fetchFeedbacks } from '../../http/feedbackAPI';
import { fetchPhotos } from '../../http/photoAPI';
import AddPhotoModal from '../modals/AddPhotoModal';
import PhotoCard from '../Galery/PhotoCard';
import { Button } from 'antd';
import { fetchService, fetchServices } from '../../http/serviceAPI';
import AddServiceModal from '../modals/AddServiceModal';
import UpdateServiceModal from '../modals/UpdateServiceModal';
import UploadPriceList from '../commonComponents/UploadPriceList';
import PersonalModal from '../modals/PersonalModal';
import { deletePersonal, fetchPersonals, fetchPersonal } from '../../http/personalAPI';

const Admin = () => {
  const { user } = useContext(Context);
  const [data, setData] = useState([]);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [isDoctorModalOpen, setIsDoctorModalOpen] = useState(false);
  const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isVacancyModalOpen, setIsVacancyModalOpen] = useState(false);
  const [isSpecialOfferModalOpen, setIsSpecialOfferModalOpen] = useState(false);
  const [isServiceModalOpen, setIsServiceModalOpen] = useState(false);

  const [deleter, setDeleter] = useState(() => deleteDoctor);

  const [currentEntityType, setCurrentEntityType] = useState('doctors');
  const navigate = useNavigate()
  useEffect(() => {
    loadDoctors();
  }, []);
  const handleDelete = (deletedId) => {
    setData((prev) => prev.filter((p) => p.id !== deletedId));
  };
  // Load doctors
  const loadDoctors = async () => {
    try {
      const doctors = await fetchDoctors();
      doctors.forEach(doc => {
        delete doc.departmentId;
      });
      setDeleter(() => deleteDoctor);
      setData(doctors);
      setCurrentEntityType('doctors');
    } catch (error) {
      console.error('Failed to fetch doctors:', error);
    }
  };

  // Load personals
  const loadPersonals = async () => {
    try {
      const personals = await fetchPersonals();
      console.log("personals", personals);
      setDeleter(() => deletePersonal);
      setData(personals);
      setCurrentEntityType('personals');
    } catch (error) {
      console.error('Failed to fetch personals:', error);
    }
  };

  // Load bookings
  const loadBookings = async () => {
    try {
      const bookings = await fetchBookings();
      setDeleter(() => deleteBooking)
      setData(bookings);
      setCurrentEntityType('bookings');
    } catch (error) {
      console.error('Failed to fetch bookings:', error);
    }
  };
  //load vacancy
  const loadVacancies = async () => {
    try {
      const vacancies = await fetchVacancies();
      setDeleter(() => deleteVacancy);
      setData(vacancies);
      setCurrentEntityType('vacancies');
    } catch (error) {
      console.error('Failed to fetch vacancies:', error);
    }
  }

  //load special offer
  const loadSpecialOffers = async () => {
    try {
      const specialOffers = await fetchSpecialOffers();
      setDeleter(() => deleteSpecialOffer);
      setData(specialOffers);
      setCurrentEntityType('specialOffer')
    } catch (error) {
      console.error('Failed to fetch special offers:', error);
    }
  }

  //load feedbacks
  const loadFeedbacks = async () => {
    try {
      const feedbacks = await fetchFeedbacks();
      setData(feedbacks);
      setCurrentEntityType('feedback')
    } catch (error) {
      console.error('Failed to fetch feedbacks:', error);
    }
  }

  //load services
  const loadServices = async () => {
    try {
      const services = await fetchServices();

      const transformed = services.map(service => ({
        ...service,
        category: service.category?.nameEN || "Unknown"
      }));

      setData(transformed);
      setCurrentEntityType('services');
    } catch (error) {
      console.error('Failed to fetch services:', error);
    }
  };


  //load photos
  const loadPhotos = async () => {
    try {
      const photos = await fetchPhotos();
      setData(photos);
      setCurrentEntityType('photo');
    } catch (error) {
      console.error('Failed to fetch photos:', error);
    }
  }

  const logOut = () => {
    localStorage.setItem('token', '')
    user.setUser({})
    user.setIsAuth(false)
    user.setIsAdmin(false)
    navigate('/')
  }

  // Open modal depending on type
  const openModalUpdate = async (id) => {
    try {
      if (currentEntityType === 'doctors') {
        const doctor = await fetchDoctor(id);
        setSelectedEntityId(id);
        setSelectedEntity(doctor);
        setIsDoctorModalOpen(true);
      } else if (currentEntityType === 'personals') {
        const personal = await fetchPersonal(id);
        setSelectedEntityId(id);
        setSelectedEntity(personal);
        setIsPersonalModalOpen(true);
      }
      else if (currentEntityType === 'bookings') {
        const booking = await fetchBooking(id);
        setSelectedEntityId(id);
        setSelectedEntity(booking);
        setIsBookingModalOpen(true);
      }
      else if (currentEntityType === 'vacancies') {
        const vacancy = await fetchVacancy(id);
        setSelectedEntityId(id);
        setSelectedEntity(vacancy);
        setIsVacancyModalOpen(true);
      }
      else if (currentEntityType === 'specialOffer') {
        const specialOffer = await fetchSpecialOffer(id);
        setSelectedEntityId(id);
        setSelectedEntity(specialOffer);
        setIsVacancyModalOpen(true);
      }
      else if (currentEntityType === 'feedbacks') {
        const feedback = await fetchFeedback(id);
        setSelectedEntityId(id);
        setSelectedEntity(feedback);
        // setIsFeedbackModalOpen(true);
      }
      else if (currentEntityType === 'services') {
        const service = await fetchService(id);
        console.log("service", service);
        setSelectedEntityId(id);
        setSelectedEntity(service);
        setIsServiceModalOpen(true);
      }
    } catch (error) {
      console.error(`Failed to load ${currentEntityType} data:`, error);
    }
  };

  // Close modals
  const closeDoctorModal = () => {
    setIsDoctorModalOpen(false);
    setSelectedEntityId(null);
    setSelectedEntity(null);
  };

  const closePersonalModal = () => {
    setIsPersonalModalOpen(false);
    setSelectedEntityId(null);
    setSelectedEntity(null);
  };

  const closeBookingModal = () => {
    setIsBookingModalOpen(false);
    setSelectedEntityId(null);
    setSelectedEntity(null);
  };

  const closeVacancyModal = () => {
    setIsVacancyModalOpen(false);
    setSelectedEntityId(null);
    setSelectedEntity(null);
  };

  const closeSpecialOfferModal = () => {
    setIsSpecialOfferModalOpen(false);
    setSelectedEntityId(null);
    setSelectedEntity(null);
  };

  const closeServiceModal = () => {
    setIsServiceModalOpen(false);
    setSelectedEntityId(null);
    setSelectedEntity(null);
  }

  return (
    <div>
      <h1>Admin</h1>
      <div className="button-section d-flex">
        <AdminButton color={"cyan"} name="Բժիշկներ" onClick={loadDoctors} type="button" />
        <AdminButton color={"cyan"} name="Աշխատողներ" onClick={loadPersonals} type="button" />
        <AdminButton color={"cyan"} name="Ամրագրումներ" onClick={loadBookings} type="button" />
        <AdminButton color={"cyan"} name="Աշխատատեղեր" onClick={loadVacancies} type="button" />
        <AdminButton color={"cyan"} name="Ակցիաներ" onClick={loadSpecialOffers} type="button" />
        <AdminButton color={"cyan"} name="Կարծիքներ" onClick={loadFeedbacks} type="button" />
        <AdminButton color={"cyan"} name="Նկարներ" onClick={loadPhotos} type="button" />
        <AdminButton color={"cyan"} name="Ծառայություններ" onClick={loadServices} type="button" />
        <AdminButton color={"danger"} name="Ելք" onClick={logOut} type="button" />
      </div>

      <div className="table-section">
        {currentEntityType !== "photo" && (
          <TableMaker data={data} update={openModalUpdate} remove={(e) => deleter(e)} />
        )}
        {currentEntityType === "photo" && (
          <div className='admin-galery d-flex'>
            {(!data || data.length === 0) ? (
              <p>There are no photos in gallery</p>
            ) : (
              data.map(photo => (
                <PhotoCard key={photo.id} image={photo} onDelete={handleDelete} />
              ))
            )}
          </div>
        )}
      </div>
      <div className='add-admin-section'>
        <DoctorModal
          isOpen={isDoctorModalOpen}
          onClose={closeDoctorModal}
          doctorId={selectedEntityId}
          doctor={selectedEntity}
        />
        <PersonalModal
          isOpen={isPersonalModalOpen}
          onClose={closePersonalModal}
          personId={selectedEntityId}
          person={selectedEntity}
        />
        <UpdateBookingModal
          isOpen={isBookingModalOpen}
          onClose={closeBookingModal}
          bookingId={selectedEntityId}
          booking={selectedEntity}
        />
        <UpdateVacancyModal
          isOpen={isVacancyModalOpen}
          onClose={closeVacancyModal}
          vacancyId={selectedEntityId}
          vacancy={selectedEntity}
        />
        <UpdateServiceModal
          isOpen={isServiceModalOpen}
          onClose={closeServiceModal}
          serviceId={selectedEntityId}
          service={selectedEntity}
        />
        <UpdateSpecialOfferModal
          isOpen={isSpecialOfferModalOpen}
          onClose={closeSpecialOfferModal}
          offerId={selectedEntityId}
          offer={selectedEntity}
        />        
        <AddVacancyModal />
        <AddPhotoModal />
        <AddServiceModal />
        <Button
          color={"cyan"}
          variant="outlined"
          onClick={() => {
            setSelectedEntityId(null);
            setSelectedEntity(null);
            setIsDoctorModalOpen(true);
          }}
        >
          + Բժիշկ
        </Button>
        <Button
          color={"cyan"}
          variant="outlined"
          onClick={() => {
            setSelectedEntityId(null);
            setSelectedEntity(null);
            setIsPersonalModalOpen(true);
          }}
        >
          + Աշխատող
        </Button>
        <Button
          color={"cyan"}
          variant="outlined"
          onClick={() => {
            setSelectedEntityId(null);
            setSelectedEntity(null)
            setIsSpecialOfferModalOpen(true);
          }}
        >
          + Ակցիա
        </Button>
        <UploadPriceList id={1} />
        <UploadPriceList id={2} />
        <UploadPriceList id={3} />
      </div>

    </div>
  );
};

export default Admin;
